/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PipelineMapListGeometry
 */
export interface PipelineMapListGeometry {
    /**
     * 
     * @type {PipelineMapListGeometryTypeEnum}
     * @memberof PipelineMapListGeometry
     */
    type?: PipelineMapListGeometryTypeEnum;
    /**
     * 
     * @type {Array<Array<Array<number>>>}
     * @memberof PipelineMapListGeometry
     */
    coordinates?: Array<Array<Array<number>>>;
}


/**
 * @export
 */
export const PipelineMapListGeometryTypeEnum = {
    MultiLineString: 'MultiLineString'
} as const;
export type PipelineMapListGeometryTypeEnum = typeof PipelineMapListGeometryTypeEnum[keyof typeof PipelineMapListGeometryTypeEnum];


/**
 * Check if a given object implements the PipelineMapListGeometry interface.
 */
export function instanceOfPipelineMapListGeometry(value: object): value is PipelineMapListGeometry {
    return true;
}

export function PipelineMapListGeometryFromJSON(json: any): PipelineMapListGeometry {
    return PipelineMapListGeometryFromJSONTyped(json, false);
}

export function PipelineMapListGeometryFromJSONTyped(json: any, ignoreDiscriminator: boolean): PipelineMapListGeometry {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'coordinates': json['coordinates'] == null ? undefined : json['coordinates'],
    };
}

export function PipelineMapListGeometryToJSON(json: any): PipelineMapListGeometry {
    return PipelineMapListGeometryToJSONTyped(json, false);
}

export function PipelineMapListGeometryToJSONTyped(value?: PipelineMapListGeometry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'coordinates': value['coordinates'],
    };
}

